var _rect, _title, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _rect4, _rect5, _rect6, _rect7, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _rect8, _rect9, _rect10, _rect11, _circle;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchDevice52Ports(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229,
    height: 23,
    viewBox: "0 0 229 23",
    fill: "none",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.49870380759239197,
    y: 0.8401723131537437,
    width: 227.58299255371094,
    height: 21.835399627685547,
    fill: "#fff",
    stroke: "black",
    strokeWidth: 0.400241,
    id: "svg_1",
    className: ""
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.9540998935699463,
    y: 5.241559982299805,
    width: 12.806099891662598,
    height: 12.806099891662598,
    fill: "#fff",
    stroke: "black",
    strokeWidth: 0.370593,
    id: "svg_2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.438 5.05627H172.556V18.5074H203.438V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    id: "svg_3",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.7232012515068,5.05627 H79.84120125150682 V18.5074 H110.7232012515068 V5.05627 z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.84120125150682,5.05627 H48.95820125150681 V18.5074 H79.84120125150682 V5.05627 z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.95820125150681,5.05627 H18.07520125150681 V18.5074 H48.95820125150681 V5.05627 z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8022012515068,12.7427 H81.2132012515068 V16.6971 H83.0412012515068 V17.3789 H83.4982012515068 V17.9584 H85.5172012515068 V17.3789 H85.9742012515068 V16.6971 H87.8022012515068 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.91920125150679,12.7427 H50.33020125150679 V16.6971 H52.158201251506796 V17.3789 H52.61520125150682 V17.9584 H54.634201251506795 V17.3789 H55.09120125150682 V16.6971 H56.91920125150679 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.03620125150681,12.7427 H19.44720125150681 V16.6971 H21.2752012515068 V17.3789 H21.732201251506808 V17.9584 H23.7512012515068 V17.3789 H24.208201251506807 V16.6971 H26.03620125150681 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8602012515068,16.9978 H81.2132012515068 V17.6841 H82.8602012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.97720125150681,16.9978 H50.33020125150679 V17.6841 H51.97720125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.094201251506803,16.9978 H19.44720125150681 V17.6841 H21.094201251506803 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8012012515068,16.9978 H86.4282012515068 V17.6841 H87.8012012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_94"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.91920125150679,16.9978 H55.5462012515068 V17.6841 H56.91920125150679 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_95"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.03620125150681,16.9978 H24.663201251506806 V17.6841 H26.03620125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_96"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9392012515068,12.7427 H88.48820125150681 V16.6971 H90.28820125150679 V17.3789 H90.73820125150681 V17.9584 H92.72620125150681 V17.3789 H93.1762012515068 V16.6971 H94.9392012515068 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_97"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.05620125150679,12.7427 H57.6052012515068 V16.6971 H59.40520125150681 V17.3789 H59.8552012515068 V17.9584 H61.8432012515068 V17.3789 H62.293201251506815 V16.6971 H64.05620125150679 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_98"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.17320125150681,12.7427 H26.722201251506803 V16.6971 H28.5222012515068 V17.3789 H28.972201251506803 V17.9584 H30.960201251506803 V17.3789 H31.410201251506805 V16.6971 H33.17320125150681 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9982012515068,16.9978 H88.48820125150681 V17.6841 H89.9982012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_100"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.11420125150681,16.9978 H57.6052012515068 V17.6841 H59.11420125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_101"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.232201251506808,16.9978 H26.722201251506803 V17.6841 H28.232201251506808 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_102"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0762012515068,16.9978 H93.56620125150681 V17.6841 H95.0762012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_103"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1942012515068,16.9978 H62.684201251506806 V17.6841 H64.1942012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_104"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.31020125150681,16.9978 H31.80120125150681 V17.6841 H33.31020125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_105"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.21420125150681,12.7427 H95.76320125150681 V16.6971 H97.5632012515068 V17.3789 H98.01320125150681 V17.9584 H100.00120125150681 V17.3789 H100.4512012515068 V16.6971 H102.21420125150681 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_106"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3302012515068,12.7427 H64.8792012515068 V16.6971 H66.67920125150681 V17.3789 H67.1292012515068 V17.9584 H69.1172012515068 V17.3789 H69.56720125150682 V16.6971 H71.3302012515068 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_107"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.448201251506816,12.7427 H33.997201251506795 V16.6971 H35.797201251506806 V17.3789 H36.247201251506795 V17.9584 H38.235201251506794 V17.3789 H38.68520125150681 V16.6971 H40.448201251506816 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_108"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2732012515068,16.9978 H95.76320125150681 V17.6841 H97.2732012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_109"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.38920125150682,16.9978 H64.8792012515068 V17.6841 H66.38920125150682 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_110"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.507201251506814,16.9978 H33.997201251506795 V17.6841 H35.507201251506814 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_111"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.2132012515068,16.9978 H100.70320125150681 V17.6841 H102.2132012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_112"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3302012515068,16.9978 H69.8212012515068 V17.6841 H71.3302012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_113"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.448201251506816,16.9978 H38.9382012515068 V17.6841 H40.448201251506816 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_114"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.35120125150681,12.7427 H102.90020125150681 V16.6971 H104.7002012515068 V17.3789 H105.11320125150681 V17.9584 H107.13820125150681 V17.3789 H107.5512012515068 V16.6971 H109.35120125150681 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_115"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4682012515068,12.7427 H72.0162012515068 V16.6971 H73.81720125150682 V17.3789 H74.2292012515068 V17.9584 H76.2552012515068 V17.3789 H76.66720125150681 V16.6971 H78.4682012515068 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_116"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.58520125150682,12.7427 H41.134201251506795 V16.6971 H42.934201251506806 V17.3789 H43.34720125150682 V17.9584 H45.372201251506795 V17.3789 H45.7842012515068 V16.6971 H47.58520125150682 V12.7427 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_117"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4102012515068,16.9978 H102.90020125150681 V17.6841 H104.4102012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_118"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52620125150682,16.9978 H72.0162012515068 V17.6841 H73.52620125150682 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_119"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.64320125150681,16.9978 H41.134201251506795 V17.6841 H42.64320125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_120"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.35120125150681,16.9978 H107.84120125150682 V17.6841 H109.35120125150681 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_121"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4682012515068,16.9978 H76.95820125150681 V17.6841 H78.4682012515068 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_122"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.58520125150682,16.9978 H46.0752012515068 V17.6841 H47.58520125150682 V16.9978 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_123"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.76320125150681,10.82 L109.35120125150681,10.82 L109.35120125150681,6.865549999999999 L107.5232012515068,6.865549999999999 L107.5232012515068,6.18375 L107.06620125150681,6.18375 L107.06620125150681,5.604230000000001 L105.04820125150681,5.604230000000001 L105.04820125150681,6.18375 L104.59120125150682,6.18375 L104.59120125150682,6.865549999999999 L102.76320125150681,6.865549999999999 L102.76320125150681,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_124"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8802012515068,10.82 L78.4682012515068,10.82 L78.4682012515068,6.865549999999999 L76.6402012515068,6.865549999999999 L76.6402012515068,6.18375 L76.1832012515068,6.18375 L76.1832012515068,5.604230000000001 L74.1652012515068,5.604230000000001 L74.1652012515068,6.18375 L73.70820125150681,6.18375 L73.70820125150681,6.865549999999999 L71.8802012515068,6.865549999999999 L71.8802012515068,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_125"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.997201251506795,10.82 L47.58520125150682,10.82 L47.58520125150682,6.865549999999999 L45.757201251506814,6.865549999999999 L45.757201251506814,6.18375 L45.30020125150679,6.18375 L45.30020125150679,5.604230000000001 L43.28220125150682,5.604230000000001 L43.28220125150682,6.18375 L42.8252012515068,6.18375 L42.8252012515068,6.865549999999999 L40.997201251506795,6.865549999999999 L40.997201251506795,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_126"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M107.70420125150682,6.56635 L109.35120125150681,6.56635 L109.35120125150681,5.88007 L107.70420125150682,5.88007 L107.70420125150682,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_127"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8212012515068,6.56635 L78.4682012515068,6.56635 L78.4682012515068,5.88007 L76.8212012515068,5.88007 L76.8212012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_128"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9382012515068,6.56635 L47.58520125150682,6.56635 L47.58520125150682,5.88007 L45.9382012515068,5.88007 L45.9382012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_129"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102.76320125150681,6.56635 L104.1352012515068,6.56635 L104.1352012515068,5.88007 L102.76320125150681,5.88007 L102.76320125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_130"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8792012515068,6.56635 L73.25220125150682,6.56635 L73.25220125150682,5.88007 L71.8792012515068,5.88007 L71.8792012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_131"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.997201251506795,6.56635 L42.37020125150681,6.56635 L42.37020125150681,5.88007 L40.997201251506795,5.88007 L40.997201251506795,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_132"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.62520125150681,10.82 L102.0762012515068,10.82 L102.0762012515068,6.865549999999999 L100.27620125150682,6.865549999999999 L100.27620125150682,6.18375 L99.8262012515068,6.18375 L99.8262012515068,5.604230000000001 L97.8382012515068,5.604230000000001 L97.8382012515068,6.18375 L97.38820125150681,6.18375 L97.38820125150681,6.865549999999999 L95.62520125150681,6.865549999999999 L95.62520125150681,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_133"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7432012515068,10.82 L71.1942012515068,10.82 L71.1942012515068,6.865549999999999 L69.39320125150681,6.865549999999999 L69.39320125150681,6.18375 L68.94320125150679,6.18375 L68.94320125150679,5.604230000000001 L66.9552012515068,5.604230000000001 L66.9552012515068,6.18375 L66.5052012515068,6.18375 L66.5052012515068,6.865549999999999 L64.7432012515068,6.865549999999999 L64.7432012515068,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_134"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M33.860201251506794,10.82 L40.311201251506816,10.82 L40.311201251506816,6.865549999999999 L38.511201251506805,6.865549999999999 L38.511201251506805,6.18375 L38.061201251506816,6.18375 L38.061201251506816,5.604230000000001 L36.073201251506816,5.604230000000001 L36.073201251506816,6.18375 L35.6232012515068,6.18375 L35.6232012515068,6.865549999999999 L33.860201251506794,6.865549999999999 L33.860201251506794,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_135"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.56620125150681,6.56635 L102.0762012515068,6.56635 L102.0762012515068,5.88007 L100.56620125150681,5.88007 L100.56620125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_136"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6842012515068,6.56635 L71.1942012515068,6.56635 L71.1942012515068,5.88007 L69.6842012515068,5.88007 L69.6842012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_137"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8012012515068,6.56635 L40.311201251506816,6.56635 L40.311201251506816,5.88007 L38.8012012515068,5.88007 L38.8012012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_138"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.48820125150681,6.56635 L96.9982012515068,6.56635 L96.9982012515068,5.88007 L95.48820125150681,5.88007 L95.48820125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_139"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6052012515068,6.56635 L66.11520125150682,6.56635 L66.11520125150682,5.88007 L64.6052012515068,5.88007 L64.6052012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_140"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.723201251506794,6.56635 L35.233201251506785,6.56635 L35.233201251506785,5.88007 L33.723201251506794,5.88007 L33.723201251506794,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_141"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M88.35120125150681,10.82 L94.8022012515068,10.82 L94.8022012515068,6.865549999999999 L93.00220125150682,6.865549999999999 L93.00220125150682,6.18375 L92.5512012515068,6.18375 L92.5512012515068,5.604230000000001 L90.5642012515068,5.604230000000001 L90.5642012515068,6.18375 L90.11420125150681,6.18375 L90.11420125150681,6.865549999999999 L88.35120125150681,6.865549999999999 L88.35120125150681,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_142"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.46720125150679,10.82 L63.91920125150679,10.82 L63.91920125150679,6.865549999999999 L62.118201251506804,6.865549999999999 L62.118201251506804,6.18375 L61.668201251506815,6.18375 L61.668201251506815,5.604230000000001 L59.680201251506816,5.604230000000001 L59.680201251506816,6.18375 L59.2302012515068,6.18375 L59.2302012515068,6.865549999999999 L57.46720125150679,6.865549999999999 L57.46720125150679,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_143"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.584201251506812,10.82 L33.035201251506805,10.82 L33.035201251506805,6.865549999999999 L31.23520125150681,6.865549999999999 L31.23520125150681,6.18375 L30.785201251506805,6.18375 L30.785201251506805,5.604230000000001 L28.797201251506806,5.604230000000001 L28.797201251506806,6.18375 L28.347201251506803,6.18375 L28.347201251506803,6.865549999999999 L26.584201251506812,6.865549999999999 L26.584201251506812,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_144"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M93.29220125150681,6.56635 L94.8022012515068,6.56635 L94.8022012515068,5.88007 L93.29220125150681,5.88007 L93.29220125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_145"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4092012515068,6.56635 L63.91920125150679,6.56635 L63.91920125150679,5.88007 L62.4092012515068,5.88007 L62.4092012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_146"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M31.526201251506805,6.56635 L33.035201251506805,6.56635 L33.035201251506805,5.88007 L31.526201251506805,5.88007 L31.526201251506805,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_147"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3502012515068,6.56635 L89.8602012515068,6.56635 L89.8602012515068,5.88007 L88.3502012515068,5.88007 L88.3502012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_148"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4682012515068,6.56635 L58.97720125150681,6.56635 L58.97720125150681,5.88007 L57.4682012515068,5.88007 L57.4682012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_149"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.585201251506803,6.56635 L28.094201251506803,6.56635 L28.094201251506803,5.88007 L26.585201251506803,5.88007 L26.585201251506803,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_150"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2132012515068,10.82 L87.6642012515068,10.82 L87.6642012515068,6.865549999999999 L85.86420125150681,6.865549999999999 L85.86420125150681,6.18375 L85.4522012515068,6.18375 L85.4522012515068,5.604230000000001 L83.4262012515068,5.604230000000001 L83.4262012515068,6.18375 L83.01420125150682,6.18375 L83.01420125150682,6.865549999999999 L81.2132012515068,6.865549999999999 L81.2132012515068,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_151"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M50.33020125150679,10.82 L56.781201251506815,10.82 L56.781201251506815,6.865549999999999 L54.9812012515068,6.865549999999999 L54.9812012515068,6.18375 L54.56820125150679,6.18375 L54.56820125150679,5.604230000000001 L52.543201251506815,5.604230000000001 L52.543201251506815,6.18375 L52.13120125150681,6.18375 L52.13120125150681,6.865549999999999 L50.33020125150679,6.865549999999999 L50.33020125150679,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_152"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.448201251506802,10.82 L25.89920125150681,10.82 L25.89920125150681,6.865549999999999 L24.0992012515068,6.865549999999999 L24.0992012515068,6.18375 L23.6862012515068,6.18375 L23.6862012515068,5.604230000000001 L21.66120125150681,5.604230000000001 L21.66120125150681,6.18375 L21.2482012515068,6.18375 L21.2482012515068,6.865549999999999 L19.448201251506802,6.865549999999999 L19.448201251506802,10.82 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_153"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.15520125150681,6.56635 L87.6642012515068,6.56635 L87.6642012515068,5.88007 L86.15520125150681,5.88007 L86.15520125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_154"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2722012515068,6.56635 L56.781201251506815,6.56635 L56.781201251506815,5.88007 L55.2722012515068,5.88007 L55.2722012515068,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_155"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.389201251506805,6.56635 L25.89920125150681,6.56635 L25.89920125150681,5.88007 L24.389201251506805,5.88007 L24.389201251506805,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_156"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81.21420125150681,6.56635 L82.7242012515068,6.56635 L82.7242012515068,5.88007 L81.21420125150681,5.88007 L81.21420125150681,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_157"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M50.33020125150679,6.56635 L51.84020125150681,6.56635 L51.84020125150681,5.88007 L50.33020125150679,5.88007 L50.33020125150679,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_158"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.448201251506802,6.56635 L20.957201251506802,6.56635 L20.957201251506802,5.88007 L19.448201251506802,5.88007 L19.448201251506802,6.56635 z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_159"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M172.556 5.05627H141.673V18.5074H172.556V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    id: "svg_4",
    className: ""
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M141.673 5.05627H110.79V18.5074H141.673V5.05627Z",
    stroke: "#231815",
    strokeWidth: 0.137257,
    strokeMiterlimit: 10,
    id: "svg_5",
    className: ""
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M216.40178974437714,5.05627 H208.85278974437713 V18.2329 H216.40178974437714 V5.05627 z",
    stroke: "#231815",
    strokeWidth: 0.381087,
    strokeMiterlimit: 10,
    id: "svg_6",
    className: ""
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M224.4272675113678,5.05627 H216.8782675113678 V18.2329 H224.4272675113678 V5.05627 z",
    stroke: "#231815",
    strokeWidth: 0.381087,
    strokeMiterlimit: 10,
    className: "",
    id: "svg_160"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M218.9862675113678,10.0658 H217.22126751136778 V13.0854 H218.9862675113678 V12.6737 H222.1232675113678 V13.0854 H224.08426751136778 V10.0658 H222.1232675113678 V10.4089 H218.9862675113678 V10.0658 z",
    stroke: "black",
    strokeWidth: 0.137257,
    className: "",
    id: "svg_161"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 218.3192675113678,
    y: 11.16349983215332,
    width: 0.6862840056419373,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    className: "",
    id: "svg_162"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 222.16226983070374,
    y: 11.16349983215332,
    width: 0.6862840056419373,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    className: "",
    id: "svg_163"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 218.3192675113678,
    y: 7.869909763336182,
    width: 4.803989887237549,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    className: "",
    id: "svg_164"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 218.3192675113678,
    y: 14.594900131225586,
    width: 4.803989887237549,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    className: "",
    id: "svg_165"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.517 12.7427H173.928V16.6971H175.756V17.3789H176.213V17.9584H178.232V17.3789H178.689V16.6971H180.517V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_7",
    className: ""
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M149.634 12.7427H143.045V16.6971H144.873V17.3789H145.33V17.9584H147.349V17.3789H147.806V16.6971H149.634V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_8",
    className: ""
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M118.751 12.7427H112.162V16.6971H113.99V17.3789H114.447V17.9584H116.466V17.3789H116.923V16.6971H118.751V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_9",
    className: ""
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M175.575 16.9978H173.928V17.6841H175.575V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_10",
    className: ""
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M144.692 16.9978H143.045V17.6841H144.692V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_11",
    className: ""
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M113.809 16.9978H112.162V17.6841H113.809V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_12",
    className: ""
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M180.516 16.9978H179.143V17.6841H180.516V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_13",
    className: ""
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M149.634 16.9978H148.261V17.6841H149.634V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_14",
    className: ""
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.751 16.9978H117.378V17.6841H118.751V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_15",
    className: ""
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M187.654 12.7427H181.203V16.6971H183.003V17.3789H183.453V17.9584H185.441V17.3789H185.891V16.6971H187.654V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_16",
    className: ""
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M156.771 12.7427H150.32V16.6971H152.12V17.3789H152.57V17.9584H154.558V17.3789H155.008V16.6971H156.771V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_17",
    className: ""
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M125.888 12.7427H119.437V16.6971H121.237V17.3789H121.687V17.9584H123.675V17.3789H124.125V16.6971H125.888V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_18",
    className: ""
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.713 16.9978H181.203V17.6841H182.713V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_19",
    className: ""
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M151.829 16.9978H150.32V17.6841H151.829V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_20",
    className: ""
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M120.947 16.9978H119.437V17.6841H120.947V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_21",
    className: ""
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M187.791 16.9978H186.281V17.6841H187.791V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_22",
    className: ""
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M156.909 16.9978H155.399V17.6841H156.909V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_23",
    className: ""
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M126.025 16.9978H124.516V17.6841H126.025V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_24",
    className: ""
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M194.929 12.7427H188.478V16.6971H190.278V17.3789H190.728V17.9584H192.716V17.3789H193.166V16.6971H194.929V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_25",
    className: ""
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M164.045 12.7427H157.594V16.6971H159.394V17.3789H159.844V17.9584H161.832V17.3789H162.282V16.6971H164.045V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_26",
    className: ""
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M133.163 12.7427H126.712V16.6971H128.512V17.3789H128.962V17.9584H130.95V17.3789H131.4V16.6971H133.163V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_27",
    className: ""
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M189.988 16.9978H188.478V17.6841H189.988V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_28",
    className: ""
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M159.104 16.9978H157.594V17.6841H159.104V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_29",
    className: ""
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 16.9978H126.712V17.6841H128.222V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_30",
    className: ""
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M194.928 16.9978H193.418V17.6841H194.928V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_31",
    className: ""
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M164.045 16.9978H162.536V17.6841H164.045V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_32",
    className: ""
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M133.163 16.9978H131.653V17.6841H133.163V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_33",
    className: ""
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M202.066 12.7427H195.615V16.6971H197.415V17.3789H197.828V17.9584H199.853V17.3789H200.266V16.6971H202.066V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_34",
    className: ""
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M171.183 12.7427H164.731V16.6971H166.532V17.3789H166.944V17.9584H168.97V17.3789H169.382V16.6971H171.183V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_35",
    className: ""
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M140.3 12.7427H133.849V16.6971H135.649V17.3789H136.062V17.9584H138.087V17.3789H138.499V16.6971H140.3V12.7427Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_36",
    className: ""
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M197.125 16.9978H195.615V17.6841H197.125V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_37",
    className: ""
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M166.241 16.9978H164.731V17.6841H166.241V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_38",
    className: ""
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M135.358 16.9978H133.849V17.6841H135.358V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_39",
    className: ""
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M202.066 16.9978H200.556V17.6841H202.066V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_40",
    className: ""
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M171.183 16.9978H169.673V17.6841H171.183V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_41",
    className: ""
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M140.3 16.9978H138.79V17.6841H140.3V16.9978Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_42",
    className: ""
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M195.478 10.82L202.066 10.82L202.066 6.86555L200.238 6.86555L200.238 6.18375L199.781 6.18375L199.781 5.60423L197.763 5.60423L197.763 6.18375L197.306 6.18375L197.306 6.86555L195.478 6.86555L195.478 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_43",
    className: ""
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M164.595 10.82L171.183 10.82L171.183 6.86555L169.355 6.86555L169.355 6.18375L168.898 6.18375L168.898 5.60423L166.88 5.60423L166.88 6.18375L166.423 6.18375L166.423 6.86555L164.595 6.86555L164.595 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_44",
    className: ""
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M133.712 10.82L140.3 10.82L140.3 6.86555L138.472 6.86555L138.472 6.18375L138.015 6.18375L138.015 5.60423L135.997 5.60423L135.997 6.18375L135.54 6.18375L135.54 6.86555L133.712 6.86555L133.712 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_45",
    className: ""
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M200.419 6.56635L202.066 6.56635L202.066 5.88007L200.419 5.88007L200.419 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_46",
    className: ""
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M169.536 6.56635L171.183 6.56635L171.183 5.88007L169.536 5.88007L169.536 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_47",
    className: ""
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M138.653 6.56635L140.3 6.56635L140.3 5.88007L138.653 5.88007L138.653 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_48",
    className: ""
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M195.478 6.56635L196.85 6.56635L196.85 5.88007L195.478 5.88007L195.478 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_49",
    className: ""
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M164.594 6.56635L165.967 6.56635L165.967 5.88007L164.594 5.88007L164.594 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_50",
    className: ""
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M133.712 6.56635L135.085 6.56635L135.085 5.88007L133.712 5.88007L133.712 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_51",
    className: ""
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34 10.82L194.791 10.82L194.791 6.86555L192.991 6.86555L192.991 6.18375L192.541 6.18375L192.541 5.60423L190.553 5.60423L190.553 6.18375L190.103 6.18375L190.103 6.86555L188.34 6.86555L188.34 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_52",
    className: ""
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M157.458 10.82L163.909 10.82L163.909 6.86555L162.108 6.86555L162.108 6.18375L161.658 6.18375L161.658 5.60423L159.67 5.60423L159.67 6.18375L159.22 6.18375L159.22 6.86555L157.458 6.86555L157.458 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_53",
    className: ""
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M126.575 10.82L133.026 10.82L133.026 6.86555L131.226 6.86555L131.226 6.18375L130.776 6.18375L130.776 5.60423L128.788 5.60423L128.788 6.18375L128.338 6.18375L128.338 6.86555L126.575 6.86555L126.575 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_54",
    className: ""
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M193.281 6.56635L194.791 6.56635L194.791 5.88007L193.281 5.88007L193.281 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_55",
    className: ""
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M162.399 6.56635L163.909 6.56635L163.909 5.88007L162.399 5.88007L162.399 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_56",
    className: ""
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M131.516 6.56635L133.026 6.56635L133.026 5.88007L131.516 5.88007L131.516 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_57",
    className: ""
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M188.203 6.56635L189.713 6.56635L189.713 5.88007L188.203 5.88007L188.203 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_58",
    className: ""
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M157.32 6.56635L158.83 6.56635L158.83 5.88007L157.32 5.88007L157.32 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_59",
    className: ""
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M126.438 6.56635L127.948 6.56635L127.948 5.88007L126.438 5.88007L126.438 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_60",
    className: ""
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M181.066 10.82L187.517 10.82L187.517 6.86555L185.717 6.86555L185.717 6.18375L185.266 6.18375L185.266 5.60423L183.279 5.60423L183.279 6.18375L182.829 6.18375L182.829 6.86555L181.066 6.86555L181.066 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_61",
    className: ""
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M150.182 10.82L156.634 10.82L156.634 6.86555L154.833 6.86555L154.833 6.18375L154.383 6.18375L154.383 5.60423L152.395 5.60423L152.395 6.18375L151.945 6.18375L151.945 6.86555L150.182 6.86555L150.182 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_62",
    className: ""
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M119.299 10.82L125.75 10.82L125.75 6.86555L123.95 6.86555L123.95 6.18375L123.5 6.18375L123.5 5.60423L121.512 5.60423L121.512 6.18375L121.062 6.18375L121.062 6.86555L119.299 6.86555L119.299 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_63",
    className: ""
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M186.007 6.56635L187.517 6.56635L187.517 5.88007L186.007 5.88007L186.007 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_64",
    className: ""
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M155.124 6.56635L156.634 6.56635L156.634 5.88007L155.124 5.88007L155.124 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_65",
    className: ""
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M124.241 6.56635L125.75 6.56635L125.75 5.88007L124.241 5.88007L124.241 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_66",
    className: ""
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M181.065 6.56635L182.575 6.56635L182.575 5.88007L181.065 5.88007L181.065 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_67",
    className: ""
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M150.183 6.56635L151.692 6.56635L151.692 5.88007L150.183 5.88007L150.183 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_68",
    className: ""
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M119.3 6.56635L120.809 6.56635L120.809 5.88007L119.3 5.88007L119.3 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_69",
    className: ""
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M173.928 10.82L180.379 10.82L180.379 6.86555L178.579 6.86555L178.579 6.18375L178.167 6.18375L178.167 5.60423L176.141 5.60423L176.141 6.18375L175.729 6.18375L175.729 6.86555L173.928 6.86555L173.928 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_70",
    className: ""
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M143.045 10.82L149.496 10.82L149.496 6.86555L147.696 6.86555L147.696 6.18375L147.283 6.18375L147.283 5.60423L145.258 5.60423L145.258 6.18375L144.846 6.18375L144.846 6.86555L143.045 6.86555L143.045 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_71",
    className: ""
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M112.163 10.82L118.614 10.82L118.614 6.86555L116.814 6.86555L116.814 6.18375L116.401 6.18375L116.401 5.60423L114.376 5.60423L114.376 6.18375L113.963 6.18375L113.963 6.86555L112.163 6.86555L112.163 10.82Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_72",
    className: ""
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 6.56635L180.379 6.56635L180.379 5.88007L178.87 5.88007L178.87 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_73",
    className: ""
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M147.987 6.56635L149.496 6.56635L149.496 5.88007L147.987 5.88007L147.987 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_74",
    className: ""
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M117.104 6.56635L118.614 6.56635L118.614 5.88007L117.104 5.88007L117.104 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_75",
    className: ""
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M173.929 6.56635L175.439 6.56635L175.439 5.88007L173.929 5.88007L173.929 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_76",
    className: ""
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M143.045 6.56635L144.555 6.56635L144.555 5.88007L143.045 5.88007L143.045 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_77",
    className: ""
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M112.163 6.56635L113.672 6.56635L113.672 5.88007L112.163 5.88007L112.163 6.56635Z",
    stroke: "#231815",
    strokeWidth: 0.0866107,
    strokeMiterlimit: 10,
    id: "svg_78",
    className: ""
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M210.96078974437714,10.0658 H209.19578974437712 V13.0854 H210.96078974437714 V12.6737 H214.09778974437714 V13.0854 H216.05878974437712 V10.0658 H214.09778974437714 V10.4089 H210.96078974437714 V10.0658 z",
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_79",
    className: ""
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 210.29378974437714,
    y: 11.16349983215332,
    width: 0.6862840056419373,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_80",
    className: ""
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 214.13679206371307,
    y: 11.16349983215332,
    width: 0.6862840056419373,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_81",
    className: ""
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.29378974437714,
    y: 7.869909763336182,
    width: 4.803989887237549,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_82",
    className: ""
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210.29378974437714,
    y: 14.594900131225586,
    width: 4.803989887237549,
    height: 0.6862840056419373,
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_83",
    className: ""
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 223.61500549316406,
    cy: 21.115400314331055,
    r: 0.4803990125656128,
    stroke: "black",
    strokeWidth: 0.137257,
    id: "svg_84"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDevice52Ports);
export default __webpack_public_path__ + "static/media/switch-device-52-ports.df1db7a7da095051a7004df9b43a48f6.svg";
export { ForwardRef as ReactComponent };